import React from 'react';
import { Button } from '@/components/ui/button';
import { Phone, Calendar } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface ServiceCTAProps {
  title: string;
  description: string;
}

const ServiceCTA = ({ title, description }: ServiceCTAProps) => {
  const navigate = useNavigate();

  const handleGetEstimate = () => {
    navigate('/#contact');
  };

  return (
    <section className="bg-ventura-blue text-white py-16">
      <div className="container mx-auto px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          {title}
        </h2>
        
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto opacity-90">
          {description}
        </p>
        
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Button 
            className="bg-white text-ventura-blue hover:bg-gray-100 text-lg px-8 py-6"
            onClick={() => window.location.href = "tel:+18054647166"}
          >
            <Phone className="mr-2" size={20} />
            Call (805) 464-7166
          </Button>
          
          <Button 
            className="bg-ventura-green text-white hover:bg-green-600 text-lg px-8 py-6"
            onClick={handleGetEstimate}
          >
            <Calendar className="mr-2" size={20} />
            Get Free Estimate
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ServiceCTA;